module.exports = __webpack_public_path__ + "img/23400.8ff1350a.jpg";